<div class="row">
  <div class="sidebar">
    <app-header></app-header>
    <app-sidebar
      *ngIf="layout.isSidebarOnly"
      [isExpanded]="sidebarExpanded"
      (toggleSidebar)="sidebarExpanded = !sidebarExpanded"></app-sidebar>
  </div>
  <div class="display-content">
    <div
      class="content container-fluid logged-in flex-1 flex-child"
      [ngClass]="{ 'sidebar-minimize': !sidebarExpanded }">
      <router-outlet></router-outlet>
      <p-scrollTop
        target="parent"
        [styleClass]="layout.showFooter ? 'scrolltop-position' : ''"
        [threshold]="100"
        icon="pi pi-arrow-up"></p-scrollTop>
    </div>
  </div>
</div>

<!-- <app-footer *ngIf="layout.showFooter"></app-footer> -->
